<template>
  <painel-component :items="itemsOne">
    <form>
      <row-component>
        <col-component class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
          <label>Cliente:</label>
          <div class="input-container">
            <input-component v-model="selectedClientName" placeholder="Cliente" disabled />
            <button-submit class="btn-modal-search" icon="search" @click="openModalClient = true" />
          </div>
        </col-component>

        <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
          <label>Tipo de data:</label>
          <MultiSelect v-model="formData.date_type" placeholder="Tipo de data" :options="selectTypeDataCheckManagement" />
        </col-component>
      </row-component>

      <row-component>
        <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
          <label>Número:</label>
          <input-component v-model="formData.number" placeholder="Número" />
        </col-component>

        <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
          <label>Nome do emissor:</label>
          <input-component v-model="formData.issuer_name" placeholder="Nome do emissor" />
        </col-component>

        <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
          <label>Status:</label>
          <MultiSelect v-model="formData.status" placeholder="Status" :options="selectStatusCheckManagement" />
        </col-component>
      </row-component>

      <row-component>
        <col-component class-col="col-xxl-2 col-xl-2 col-lg-3 col-md-12 col-sm-12 col-12">
          <label>Data inicial:</label>
          <input-component v-mask="'##/##/####'" v-model="formData.date_start" placeholder="00/00/0000" />
        </col-component>

        <col-component class-col="col-xxl-2 col-xl-2 col-lg-3 col-md-12 col-sm-12 col-12">
          <label>Data final:</label>
          <input-component v-mask="'##/##/####'" v-model="formData.date_end" placeholder="00/00/0000" />
        </col-component>
      </row-component>

      <row-component>
        <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <button-submit class="me-1" @click="submit" icon="search" name="Pesquisar" />
          <button-route v-if="buttonCheck.create" :items="itemsTwo" />
        </col-component>
      </row-component>
    </form>

    <row-component>
      <col-component class-col="col-xxl-3 col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="alert alert-secondary d-flex justify-content-between align-items-center card-check">
          <div>
            <p class="mb-1">Total compensado</p>
            <p class="mb-0">Valor <strong>R$: {{ totals.total_compensated }}</strong></p>
          </div>
          <i class="check circle icon fs-3 text-success"></i>
        </div>
      </col-component>

      <col-component class-col="col-xxl-3 col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="alert alert-secondary d-flex justify-content-between align-items-center card-check">
          <div>
            <p class="mb-1">Total a vencer</p>
            <p class="mb-0">Valor <strong>R$: {{ totals.total_due }}</strong></p>
          </div>
          <i class="calendar alternate icon fs-3 text-success"></i>
        </div>
      </col-component>

      <col-component class-col="col-xxl-3 col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="alert alert-secondary d-flex justify-content-between align-items-center card-check">
          <div>
            <p class="mb-1">Total vencido</p>
            <p class="mb-0">Valor <strong>R$: {{ totals.total_overdue }}</strong></p>
          </div>
          <i class="exclamation triangle icon fs-3 text-danger"></i>
        </div>
      </col-component>

      <col-component class-col="col-xxl-3 col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
        <div class="alert alert-secondary d-flex justify-content-between align-items-center card-check">
          <div>
            <p class="mb-1">Total geral</p>
            <p class="mb-0">Valor <strong>R$: {{ totals.total_general }}</strong></p>
          </div>
          <i class="money bill alternate icon fs-3 text-success"></i>
        </div>
      </col-component>
    </row-component>

    <div class="bg-body-secondaryd">
      <div class="bg-white">
        <div class="__table">
          <table class="table table-striped" v-if="viewPage">
            <thead>
              <tr>
                <th scope="col" style="width: 12%">Número</th>
                <th scope="col" style="width: 28%">Cliente</th>
                <th scope="col" style="width: 18%">Banco</th>
                <th scope="col" style="width: 12%">Agência</th>
                <th scope="col" style="width: 15%">Status</th>
                <th scope="col" style="width: 15%" v-if="buttonCheck.edit || buttonCheck.delete">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(data, index) in object.data" :key="index">
                <td data-label="Número">{{ data.number }}</td>
                <td data-label="Cliente" class="name">
                  <img
                    v-if="data.client_photo"
                    class="image-desc rounded-circle me-2"
                    height="40"
                    width="40"
                    :src="data.client_photo"
                    alt=""
                  />
                  <img
                    v-else
                    class="image-desc rounded-circle me-2"
                    height="40"
                    width="40"
                    src="@/assets/avatar.png"
                    alt=""
                  />
                  {{ data.client_name }}
                </td>
                <td data-label="Banco">{{ bankLabel(data.bank) }}</td>
                <td data-label="Agência">{{ data.agency }}</td>
                <td data-label="Status">{{ statusString(data.status) }}</td>
                <td data-label="Ações" v-if="buttonCheck.edit || buttonCheck.delete">
                  <button-edit v-if="buttonCheck.edit" :id="data.id" route="check-management-edit" />
                  <button-delete v-if="buttonCheck.delete" @click="destroy(data)" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <button-pagination :pagination="object" :offset="3" @paginate="loadItems" />

    <OrderPartClientSearch
      v-if="openModalClient"
      @close="openModalClient = false"
      @select="handleClientSelection"
    />
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import ColComponent from '@/components/row/ColComponent';
import InputComponent from '@/components/form/InputComponent';
import MultiSelect from '@/components/form/MultiSelect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonDelete from '@/components/buttons/ButtonDelete';
import ButtonPagination from '@/components/buttons/ButtonPagination';
import OrderPartClientSearch from '@/components/modal/OrderPartClientSearch.vue';
import '@/assets/css/table.css';

import { mask } from 'vue-the-mask';
import { useToast } from 'vue-toastification';
import swal from 'sweetalert';

const toast = useToast();
export default {
  name: 'CheckManagementSearch',

  components: {
    ButtonPagination,
    ButtonDelete,
    ButtonEdit,
    ButtonRoute,
    ButtonSubmit,
    MultiSelect,
    InputComponent,
    ColComponent,
    RowComponent,
    PainelComponent,
    OrderPartClientSearch
  },

  directives: {
    mask
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Controle de Cheques');
    this.setDefaultDates();
    this.loadItems(1);
    this.checkACL();
  },

  data() {
    const year = new Date().getFullYear();
    return {
      itemsOne: {
        title: 'Pesquisar',
        icon: 'list alternate'
      },

      itemsTwo: {
        route: '/check-management/create',
        icon: 'plus',
        name: 'Adicionar'
      },

      buttonCheck: {
        create: false,
        edit: false,
        delete: false
      },

      formData: {
        client_id: '',
        number: '',
        issuer_name: '',
        status: '',
        date_type: 1,
        date_start: `01/01/${year}`,
        date_end: `31/12/${year}`
      },

      selectedClientName: '',
      openModalClient: false,
      viewPage: false,
      searchSubmit: false
    };
  },

  methods: {
    setDefaultDates() {
      const year = new Date().getFullYear();
      this.formData.date_start = `01/01/${year}`;
      this.formData.date_end = `31/12/${year}`;
      this.formData.date_type = 1;
    },

    submit() {
      this.loadItems(1);
      this.searchSubmit = true;
    },

    loadItems(page) {
      if (!this.searchSubmit) {
        this.$store
          .dispatch('loadCheckManagements', { ...this.params, page })
          .then(r => {
            if (this.searchSubmit) {
              this.searchSubmit = false;
              if (!r.data || r.data.length === 0) {
                toast.info('Nada foi encontrado com os parâmetros informados!', { timeout: 2000 });
              }
            }
          })
          .catch(() => {
            this.searchSubmit = false;
          });
      }
    },

    handleClientSelection(client) {
      this.formData.client_id = client.id;
      this.selectedClientName = client.surname || client.name;
      this.openModalClient = false;
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 26)
        .then(r => {
          if (r.indexOf('check-management-search') !== -1) {
            this.viewPage = true;

            if (r.indexOf('check-management-create') !== -1) {
              this.buttonCheck.create = true;
            }

            if (r.indexOf('check-management-edit') !== -1) {
              this.buttonCheck.edit = true;
            }

            if (r.indexOf('check-management-delete') !== -1) {
              this.buttonCheck.delete = true;
            }
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    },

    destroy(item) {
      swal({
        title: 'Atenção!',
        text: `Deseja realmente deletar o cheque de número ${item.number || ''}?`,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: 'Não',
            visible: true,
            closeModal: true
          },
          confirm: 'Sim'
        }
      }).then(result => {
        if (result) {
          this.$store
            .dispatch('destroyCheckManagement', item.id)
            .then(() => {
              this.loadItems(1);
              toast.success('Cadastro deletado com sucesso', { timeout: 1500 });
            })
            .catch(() => {
              toast.error('Não foi possível deletar o cheque', { timeout: 1500 });
            });
        }
      });
    },

    statusString(value) {
      const status = this.selectStatusCheckManagement.find(item => Number(item.value) === Number(value));
      return status ? status.label : '';
    },

    bankLabel(value) {
      const bank = this.selectBankList.find(item => String(item.value) === String(value).padStart(3, '0'));
      return bank ? bank.label : value;
    }
  },

  computed: {
    selectStatusCheckManagement() {
      return this.$store.state.var.selectStatusCheckManagement;
    },

    selectTypeDataCheckManagement() {
      return this.$store.state.var.selectTypeDataCheckManagement;
    },

    selectBankList() {
      return this.$store.state.var.selectBankList;
    },

    object() {
      return this.$store.state.check_management.items;
    },

    totals() {
      return this.$store.state.check_management.totals;
    },

    params() {
      return {
        page: this.object.current_page,
        client_id: this.formData.client_id,
        name_client: this.selectedClientName,
        number: this.formData.number,
        issuer_name: this.formData.issuer_name,
        status: this.formData.status,
        date_type: this.formData.date_type,
        date_start: this.formData.date_start,
        date_end: this.formData.date_end
      };
    }
  }
};
</script>

<style scoped>
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-modal-search {
  padding-top: 9.5px;
  padding-bottom: 5px;
}

.card-check {
  border-radius: 0;
}

@media (max-width: 991px) {
  .name {
    padding: 5px;
  }

  .image-desc {
    width: 35px;
    height: 35px;
  }
}
</style>
